import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface PaymentSummaryProps {
  property: {
    title: string;
    location: string;
    image: string;
    price: string;
    escrowFee: string;
    legalFee: string;
    total: string;
  };
}
const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  property
}) => {
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-415">
      <h2 className="text-xl font-bold mb-4" data-id="element-416">Payment Summary</h2>
      <div className="mb-4" data-id="element-417">
        <img src={property.image} alt={property.title} className="w-full h-32 object-cover rounded-lg mb-3" data-id="element-418" />
        <h3 className="font-bold" data-id="element-419">{property.title}</h3>
        <p className="text-gray-600 text-sm" data-id="element-420">{property.location}</p>
      </div>
      <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-421">
        <div className="space-y-2" data-id="element-422">
          <div className="flex justify-between" data-id="element-423">
            <span className="text-gray-600" data-id="element-424">Property Price</span>
            <span className="font-medium" data-id="element-425">{property.price}</span>
          </div>
          <div className="flex justify-between" data-id="element-426">
            <span className="text-gray-600" data-id="element-427">Escrow Fee (1%)</span>
            <span data-id="element-428">{property.escrowFee}</span>
          </div>
          <div className="flex justify-between" data-id="element-429">
            <span className="text-gray-600" data-id="element-430">Legal Verification Fee</span>
            <span data-id="element-431">{property.legalFee}</span>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-4 pt-4" data-id="element-432">
          <div className="flex justify-between font-bold" data-id="element-433">
            <span data-id="element-434">Total</span>
            <span data-id="element-435">{property.total}</span>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-blue-50 rounded-lg p-3 flex items-start" data-id="element-436">
        <ShieldCheckIcon size={18} className="text-blue-600 mr-2 mt-0.5" data-id="element-437" />
        <p className="text-sm text-blue-800" data-id="element-438">
          Your payment is protected by our secure escrow system. Funds will only
          be released when all verification steps are complete.
        </p>
      </div>
    </div>;
};
export default PaymentSummary;